// extracted by mini-css-extract-plugin
export default {"chapterName":"PaperHeader_chapterName__gC+rb","sectionImage":"PaperHeader_sectionImage__qyPe3"};